var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"cloud-icon",class:_vm.classes},[_c('div',{ref:"svg",staticClass:"icon svgicon",style:({width: _vm.width ? _vm.width + 'px' : null, height: _vm.height ? _vm.height + 'px' : null}),domProps:{"innerHTML":_vm._s(_vm.inner)},on:{"click":function($event){return _vm.$emit('click', $event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }